module.exports = __webpack_public_path__ + "img/ic_memo_document.264a066d.svg";